(function () {
  'use strict';

  var config = window.bloomingfulCartMonitorConfig || {};
  var endpoint = String(config.endpoint || '').replace(/\/$/, '');
  var selector = '[data-bf-hff-affiliate-link], [data-bf-hff-cart-link], a[href], area[href]';

  if (!endpoint || typeof window.fetch !== 'function') return;

  setTrackerStatus('initializing');
  var privacyReady = loadCustomerPrivacy().then(function (ready) {
    setTrackerStatus(ready ? 'ready' : 'privacy-api-unavailable');
    return ready;
  });

  document.addEventListener('click', recordClick, true);
  document.addEventListener('auxclick', function (event) {
    if (event.button === 1) recordClick(event);
  }, true);

  function recordClick(event) {
    var target = event.target && event.target.closest ? event.target.closest(selector) : null;
    var destinationUrl = target && (target.href || target.getAttribute('href'));
    if (!target || !isApprovedHffDestination(destinationUrl) || target.getAttribute('aria-disabled') === 'true' || target.classList.contains('is-disabled')) return;
    if (event.isTrusted === false) {
      setTrackerStatus('ignored-untrusted');
      return;
    }

    setTrackerStatus('click-received');

    var customer = window.bloomingfulCustomerInfo || {};
    var product = productContext(target);
    var payload = {
      event_id: randomId(),
      event_at: new Date().toISOString(),
      client_id: getClientId(),
      shop_domain: config.shopDomain,
      theme_id: String(config.themeId || ''),
      page_path: window.location.pathname,
      source_page_title: cleanText(config.pageTitle || document.title, 240),
      action: target.hasAttribute('data-bf-hff-cart-link') ? 'add_to_cart' : 'learn_more',
      button_label: linkLabel(target),
      product_id: product.id,
      product_handle: product.handle,
      product_title: product.title,
      variant_id: product.variantId,
      variant_title: product.variantTitle,
      destination_url: destinationUrl,
      customer: {
        id: customer.id || '',
        email: customer.email || '',
        name: customer.name || '',
        company: customer.company || '',
        pricing_groups: pricingGroups(customer.tags || [])
      },
      location: {
        account_city: customer.accountCity || '',
        account_region: customer.accountRegion || '',
        account_country: customer.accountCountry || ''
      }
    };
    privacyReady.then(function (ready) {
      if (!ready) {
        setTrackerStatus('privacy-api-unavailable');
        return;
      }
      if (!analyticsAllowed()) {
        setTrackerStatus('consent-blocked');
        return;
      }
      payload.visit = visitContext();
      send(payload);
    });
  }

  function isApprovedHffDestination(value) {
    try {
      var url = new URL(String(value || ''), window.location.href);
      var host = url.hostname.toLowerCase();
      return url.protocol === 'https:' && (host === 'herbalfacefood.com' || host.endsWith('.herbalfacefood.com'));
    } catch (error) {
      return false;
    }
  }

  function linkLabel(target) {
    var image = target.querySelector && target.querySelector('img[alt]');
    var candidates = [
      target.textContent,
      target.getAttribute('aria-label'),
      target.getAttribute('title'),
      image && image.getAttribute('alt'),
      'Herbal Face Food link'
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      var label = cleanText(candidates[index], 80);
      if (label) return label;
    }
    return 'Herbal Face Food link';
  }

  function productContext(target) {
    var container = target.closest('[data-product-id], [data-product-handle], [data-product-title]');
    var productPathHandle = productHandleFromPath(window.location.pathname);
    return {
      id: dataValue(target, container, 'data-product-id'),
      handle: dataValue(target, container, 'data-product-handle') || productPathHandle,
      title: dataValue(target, container, 'data-product-title') || (productPathHandle ? cleanText(config.pageTitle || document.title, 240) : ''),
      variantId: dataValue(target, container, 'data-variant-id'),
      variantTitle: dataValue(target, container, 'data-variant-title')
    };
  }

  function dataValue(target, container, name) {
    return cleanText(target.getAttribute(name) || (container && container.getAttribute(name)) || '', 240);
  }

  function productHandleFromPath(path) {
    var match = String(path || '').match(/^\/products\/([a-z0-9][a-z0-9-]*)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function visitContext() {
    var visit = parseStoredJson(readStorage('bloomingful:cartMonitorVisit')) || {};
    var state = parseStoredJson(readStorage('bloomingful:cartMonitorVisitState')) || {};
    var referrer = safeReferrer(visit.referrer_url || state.referrer_url || document.referrer);
    return {
      visitor_hash: validHash(visit.visitor_hash),
      visit_hash: validHash(visit.visit_hash),
      visit_number: Math.max(1, Number(visit.visit_number || state.visit_number || 1)),
      started_at: visit.started_at || state.started_at || '',
      landing_path: visit.landing_path || state.landing_path || window.location.pathname,
      landing_title: visit.landing_title || state.landing_title || config.pageTitle || document.title || '',
      referrer_url: referrer.url,
      referrer_domain: visit.referrer_domain || state.referrer_domain || referrer.domain,
      utm_source: visit.utm_source || state.utm_source || campaignValue('utm_source'),
      utm_medium: visit.utm_medium || state.utm_medium || campaignValue('utm_medium'),
      utm_campaign: visit.utm_campaign || state.utm_campaign || campaignValue('utm_campaign')
    };
  }

  function safeReferrer(value) {
    try {
      var url = new URL(String(value || ''));
      if (!/^https?:$/.test(url.protocol)) return { url: '', domain: '' };
      return {
        url: cleanText(url.origin + url.pathname, 500),
        domain: cleanText(url.hostname.replace(/^www\./i, '').toLowerCase(), 160)
      };
    } catch (error) {
      return { url: '', domain: '' };
    }
  }

  function campaignValue(name) {
    try {
      return cleanText(new URLSearchParams(window.location.search).get(name), 120);
    } catch (error) {
      return '';
    }
  }

  function validHash(value) {
    var hash = String(value || '').toLowerCase();
    return /^[a-f0-9]{64}$/.test(hash) ? hash : '';
  }

  function parseStoredJson(value) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return null;
    }
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function loadCustomerPrivacy() {
    return new Promise(function (resolve) {
      var attempts = 0;
      var settled = false;
      var timeout = window.setTimeout(function () {
        finish(Boolean(window.Shopify && window.Shopify.customerPrivacy));
      }, 5000);

      function finish(ready) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(ready);
      }

      function load() {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          finish(true);
          return;
        }

        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
            finish(!error && Boolean(window.Shopify.customerPrivacy));
          });
          return;
        }

        attempts += 1;
        if (attempts < 30) {
          window.setTimeout(load, 100);
          return;
        }
        finish(false);
      }

      load();
    });
  }

  function analyticsAllowed() {
    try {
      return Boolean(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function send(payload) {
    var url = endpoint + '/api/cart-monitor/hff-click';
    var body = JSON.stringify(payload);
    setTrackerStatus('sending');
    window.fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: body
    }).then(function (response) {
      setTrackerStatus(response.ok ? 'recorded' : 'http-error-' + response.status);
    }).catch(function () {
      if (window.navigator && typeof window.navigator.sendBeacon === 'function' && window.navigator.sendBeacon(url, body)) {
        setTrackerStatus('beacon-queued');
        return;
      }
      setTrackerStatus('send-failed');
    });
  }

  function setTrackerStatus(status) {
    document.documentElement.setAttribute('data-bf-hff-tracker-status', status);
  }

  function getClientId() {
    try {
      var current = window.sessionStorage.getItem('bloomingful:cartMonitorClientId');
      if (current) return current;
      current = randomId();
      window.sessionStorage.setItem('bloomingful:cartMonitorClientId', current);
      return current;
    } catch (error) {
      return randomId();
    }
  }

  function pricingGroups(tags) {
    var normalizedTags = (Array.isArray(tags) ? tags : []).map(function (tag) { return String(tag || '').trim().toLowerCase(); });
    var ruleMap = window.bloomingfulWsaioRuleMap || {};
    var groups = [];
    (ruleMap.rules || []).forEach(function (rule) {
      if (String(rule.customerGroup || '').toLowerCase() !== 'has_tag') return;
      (rule.tags || []).forEach(function (tag) {
        var normalized = String(tag || '').trim().toLowerCase();
        if (normalized && normalized !== 'all' && normalizedTags.indexOf(normalized) !== -1) groups.push(String(tag).toUpperCase());
      });
    });
    return groups.filter(function (group, index) { return groups.indexOf(group) === index; });
  }

  function randomId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    }
    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  function cleanText(value, maxLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength);
  }
})();
